export default "__VITE_PUBLIC_ASSET__f9ec257d__"